import img1 from '../images/about-img-1.jpeg';
const AboutUs = () => {
  return (
    <>
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 relative overflow-hidden text-start">
        {/* Decorative elements - responsive positioning */}
        <div className="absolute top-0 left-0 w-full h-12 sm:h-20 bg-gradient-to-b from-white to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-12 sm:h-20 bg-gradient-to-t from-white to-transparent"></div>
        <div className="absolute -top-20 sm:-top-40 -right-20 sm:-right-40 w-40 sm:w-80 h-40 sm:h-80 bg-secondary/5 rounded-full"></div>
        <div className="absolute -bottom-10 sm:-bottom-20 -left-10 sm:-left-20 w-30 sm:w-60 h-30 sm:h-60 bg-secondary/5 rounded-full"></div>

        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          {/* Section heading with accent */}
          <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="inline-block text-xs sm:text-sm uppercase tracking-wider font-futura font-bold text-primary mb-2">
              Our Story
            </h2>
            <h3 className="font-ivyMode text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4">
              Redefining Luxury Stays
            </h3>
            <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-primary to-third mx-auto"></div>
          </div>

          {/* Main content grid - stacked on mobile, side by side on large screens */}
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
            {/* Left content */}
            <div className="space-y-6 sm:space-y-8">
              <h3 className="font-ivyMode text-2xl sm:text-3xl text-primary relative inline-block">
                Where Every Stay Unfolds an Expanse of Comfort
                <span className="absolute bottom-0 left-0 w-1/2 h-1 bg-gradient-to-r from-primary to-transparent"></span>
              </h3>

              <div className="space-y-4 sm:space-y-6 text-gray-700 leading-relaxed font-futura">
                <p className="border-l-2 sm:border-l-3 border-secondary/40 pl-3 sm:pl-4 text-sm sm:text-base">
                  Takeaya is not just another holiday home management company — we're a team of property owners who got tired of poor service, delayed payments, and empty promises. That's why we created Takeaya: to give owners a smarter, more profitable, and fully transparent management solution.
                </p>
                <p className="pl-3 sm:pl-4 text-sm sm:text-base">
                  Takeaya is not just a name; it is a philosophy. A premium vacation home and property management brand headquartered in Dubai, UAE, Takeaya redefines luxury living by offering an exclusive selection of handpicked stays, each designed to reflect a perfect harmony of comfort, elegance, and cultural authenticity.
                </p>
                <p className="pl-3 sm:pl-4 text-sm sm:text-base">
                  Our properties serve a diverse clientele — from global travelers seeking immersive stays, to property owners desiring exceptional, transparent returns.
                </p>
                <p className="pl-3 sm:pl-4 text-sm sm:text-base">
                  We seamlessly integrate cutting-edge technology with heartfelt service. With AI-driven dynamic pricing models, predictive performance monitoring, and automated guest communications, we don't just follow industry trends; we define them.
                </p>
                <p className="pl-3 sm:pl-4 text-sm sm:text-base">
                  Every space curated by Takeaya is more than a property — it is an experience, a story, a memory waiting to unfold.
                </p>
              </div>

              {/* Quote - responsive padding and font sizes */}
              <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl border-l-3 sm:border-l-4 border-secondary shadow-md font-ivyMode">
                <p className="italic text-primary/80 text-lg sm:text-xl relative">
                  <span className="absolute -top-4 -left-2 text-3xl sm:text-4xl text-primary/30">
                    "
                  </span>
                  At Takeaya, we don't manage properties; we nurture legacies.
                  <span className="absolute -bottom-4 -right-2 text-3xl sm:text-4xl text-primary/30">
                    "
                  </span>
                </p>
              </div>

              {/* Commitment box - responsive padding and layout */}
              <div className="flex items-center bg-white/80 p-4 sm:p-6 rounded-xl shadow-sm border border-secondary/10">
                <div className="bg-gradient-to-br from-secondary to-third w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center mr-4 sm:mr-5 shadow-md flex-shrink-0">
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7 text-white"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-futura text-primary text-lg sm:text-xl font-medium">
                    Our Commitment
                  </h4>
                  <p className="text-gray-600 text-sm sm:text-base">
                    Every detail matters. Every guest is family. Every owner is a valued partner.
                  </p>
                </div>
              </div>
            </div>

            {/* Right image and testimonial - responsive heights and positioning */}
            <div className="relative mt-8 lg:mt-0">
              {/* Main image with frame - responsive height */}
              <div className="relative rounded-xl overflow-hidden shadow-xl border border-secondary/20 h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px]">
                <img
                  src={img1}
                  alt="Luxury Takeaya property"
                  className="object-cover w-full h-full"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/70 to-transparent"></div>

                {/* Branding element - responsive padding and font sizes */}
                <div className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-white/90 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full shadow-md">
                  <span className="font-serif text-secondary font-medium text-sm sm:text-base">
                    Takeaya
                  </span>
                  <span className="text-xs sm:text-sm text-gray-500 ml-1 sm:ml-2">
                    | Premium Stays
                  </span>
                </div>
              </div>

              {/* Testimonial floating card - responsive positioning and sizing */}
              <div className="mx-4 sm:mx-8 absolute -bottom-6 sm:-bottom-12 -left-4 sm:-left-12 bg-white shadow-xl rounded-xl p-4 sm:p-6 md:p-8 max-w-[280px] sm:max-w-sm border border-secondary/10">
                {/* Rating */}
                <div className="flex items-center mb-2 sm:mb-3">
                  <div className="font-serif text-primary text-xl sm:text-2xl font-bold">
                    5.0
                  </div>
                  <div className="flex ml-2 inline-flex">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-500"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                      </svg>
                    ))}
                  </div>
                </div>

                {/* Testimonial text - responsive font sizes */}
                <p className="text-gray-700 font-ivyMode mb-3 sm:mb-4 italic relative text-sm sm:text-base">
                  <span className="absolute -top-2 sm:-top-3 -left-1 text-2xl sm:text-3xl text-secondary/20">
                    "
                  </span>
                  Takeaya transformed our vacation into a dream. Impeccable
                  service and stunning homes!
                  <span className="absolute -bottom-1 -right-1 text-2xl sm:text-3xl text-secondary/20">
                    "
                  </span>
                </p>

                {/* Profile - responsive sizing */}
                <div className="flex items-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-secondary/20 rounded-full mr-2 sm:mr-3 flex items-center justify-center flex-shrink-0">
                    <svg
                      className="w-5 h-5 sm:w-6 sm:h-6 text-secondary/70"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-medium text-secondary font-serif text-sm sm:text-base">
                      Amal
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500">
                      Valued Guest
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative element - hidden on small screens */}
              <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 hidden sm:block">
                <svg width="80" height="80" viewBox="0 0 100 100" fill="none" className="sm:w-[100px] sm:h-[100px]">
                  <circle
                    cx="50"
                    cy="50"
                    r="48"
                    stroke="#A3582A"
                    strokeWidth="1"
                    strokeDasharray="4 4"
                    opacity="0.3"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="30"
                    stroke="#A3582A"
                    strokeWidth="1"
                    opacity="0.2"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;